const { connect } = require('react-redux');
const stageScenarioComponent = require('../component/stageScenarioComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState, appState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_SCENARIO,
        soundEnable: appState.soundEnable,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleButtonClick: () => {
            dispatch(actions.modalDisable());
            dispatch(actions.modalEnable(modalType.MODAL_STAGE_START));
        }
    };
};

export const StageScenarioContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(stageScenarioComponent);